const simpleStroke = (data) => {
  const defaultConfig = {
    graphic: {
      elements: [
        {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: data.text,
            fontSize: data.size,
            fontWeight: 'bold',
            lineDash: [0, 200],
            lineDashOffset: 0,
            fill: 'transparent',
            stroke: data.color,
            lineWidth: 1
          },
          keyframeAnimation: {
            duration: data.duration,
            loop: true,
            keyframes: [
              {
                percent: 0.7,
                style: {
                  fill: 'transparent',
                  lineDashOffset: 200,
                  lineDash: [200, 0]
                }
              },
              {
                // Stop for a while.
                percent: 0.8,
                style: {
                  fill: 'transparent'
                }
              },
              {
                percent: 1,
                style: {
                  fill: data.color
                }
              }
            ]
          }
        }
      ]
    }
  }

  const opt = Object.assign({}, defaultConfig)
  
  return opt
}

export default simpleStroke